var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CartPanel',{on:{"toggle":_vm.toggle}}),_vm._v(" "),_c('van-popup',{staticClass:"z-[999999999999] max-w-screen-sm mx-auto inset-x-0 overflow-hidden",attrs:{"position":"bottom","round":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('CartList')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }